import { postAction } from "./request";

/**
 * 获取商品标签（分类）列表
 * @param {*} params
 * @returns
 */
export async function getContentTagList(params = {}) {
  return postAction("/cms/content/getPage/25/0", params);
}

/**
 * 获取热门商品列表
 * @param {*} params
 * @returns
 */
export async function getPopularGoodsList(params) {
  return postAction("/cms/pageTab/pageGoods", params);
}

/**
 * 获取分类下的商品列表
 * @param {*} params
 * @returns
 */
export async function getCategoryGoodsList(params) {
  return postAction("/cms/search/queryCategoryDataByPage", params);
}

/**
 * 获取最近查看的商品
 * @param {*} params
 * @returns
 */
export async function getRecentlyView(params) {
  return postAction("/cms/recommend/recentlyViewed/query", params);
}

/**
 * 获取喜爱的商品
 * @param {*} params
 * @returns
 */
export async function getFavoriteQuery(params) {
  return postAction("/gw/goodsWish/query", params);
}

/**
 * 获取购物车商品列表
 * @param {*} params
 * @returns
 */
export async function getCartList(params) {
  return postAction("/gw/cart/get/v2", params);
}

/**
 * 获取订单商品列表
 * @param {*} params
 * @returns
 */
export async function getOrderList(params) {
  return postAction("/cms/order/orderList", params);
}
